import { useEffect, useState } from 'react';
import { useT } from '../i18n';
import { useConsent } from './consent';

/**
 * Cookie lišta.
 *
 * Ukazuje se, dokud v úložišti není platná volba aktuální verze, a znovu
 * ji otevře odkaz „Nastavení cookies" v patičce. Záměrně ŽÁDNÝ overlay ani
 * freeze UI – web je plně použitelný před rozhodnutím; bez souhlasu prostě
 * neteče analytika. Tři cesty: Přijmout vše, Jen nezbytné, nebo Nastavení
 * s přepínači po kategoriích.
 */
export function CookieBanner() {
  const { t } = useT();
  const { consent, bannerOpen, decided, save, closeBanner } = useConsent();

  const [settingsOpen, setSettingsOpen] = useState(false);
  const [analytics, setAnalytics] = useState(consent.analytics);
  const [marketing, setMarketing] = useState(consent.marketing);

  // Při otevření lišty (poprvé i z patičky) srovnat přepínače s uloženou
  // volbou a detail zavřít – ať začíná vždy ze stejného stavu.
  useEffect(() => {
    if (!bannerOpen) return;
    setAnalytics(consent.analytics);
    setMarketing(consent.marketing);
    setSettingsOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bannerOpen]);

  if (!bannerOpen) return null;

  return (
    <div className="consent-banner" role="dialog" aria-label={t('consent.title')} aria-live="polite">
      <div className="consent-inner">
        <div className="consent-text">
          <strong>{t('consent.title')}</strong>
          <p className="muted small">{t('consent.text')}</p>
        </div>

        {settingsOpen && (
          <div className="consent-options">
            <label className="consent-option">
              <input type="checkbox" checked disabled />
              <span>
                <strong>{t('consent.essentialLabel')}</strong>
                <span className="muted small">{t('consent.essentialDesc')}</span>
              </span>
            </label>
            <label className="consent-option">
              <input
                type="checkbox"
                checked={analytics}
                onChange={(event) => setAnalytics(event.target.checked)}
              />
              <span>
                <strong>{t('consent.analyticsLabel')}</strong>
                <span className="muted small">{t('consent.analyticsDesc')}</span>
              </span>
            </label>
            <label className="consent-option">
              <input
                type="checkbox"
                checked={marketing}
                onChange={(event) => setMarketing(event.target.checked)}
              />
              <span>
                <strong>{t('consent.marketingLabel')}</strong>
                <span className="muted small">{t('consent.marketingDesc')}</span>
              </span>
            </label>
          </div>
        )}

        <div className="consent-actions">
          <button
            type="button"
            className="button primary"
            onClick={() => save({ analytics: true, marketing: true })}
          >
            {t('consent.acceptAll')}
          </button>
          <button
            type="button"
            className="button ghost"
            onClick={() => save({ analytics: false, marketing: false })}
          >
            {t('consent.essentialOnly')}
          </button>
          {settingsOpen ? (
            <button
              type="button"
              className="button ghost"
              onClick={() => save({ analytics, marketing })}
            >
              {t('consent.save')}
            </button>
          ) : (
            <button type="button" className="button ghost" onClick={() => setSettingsOpen(true)}>
              {t('consent.settings')}
            </button>
          )}
          {/* Křížek jen pro znovuotevřenou lištu – první rozhodnutí nejde
              odklikat pryč, ale ani neblokuje: web funguje dál. */}
          {decided && (
            <button
              type="button"
              className="consent-close"
              aria-label={t('consent.close')}
              onClick={closeBanner}
            >
              ×
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
